import { ReactNode } from 'react';
import { HeaderTech, Footer } from 'core/common/ui/widgets';
import { PageWrapperStyled, BodyStyled } from './styled';

type TechLayoutProps = {
  children: ReactNode;
};

export const TechLayout = ({ children }: TechLayoutProps) => {
  return (
    <>
      <BodyStyled>
        <HeaderTech />
        <PageWrapperStyled component="main">{children}</PageWrapperStyled>
        <Footer />
      </BodyStyled>
    </>
  );
};
